// apps/client/src/ui/items/useIcon.ts — an item's rendered icon (data URL), the placeholder until it is ready.
import { useEffect, useState } from 'react';
import type { CatalogId } from '@whiskerton/content';
import { PLACEHOLDER_ICON } from '../../assets/icons';
import { getGame } from '../../game/instance';
export function useIcon(id: CatalogId | null): string {
  const [url, setUrl] = useState(PLACEHOLDER_ICON);
  useEffect(() => {
    let live = true;
    if (id) void getGame().assets.icon(id).then((u) => { if (live) setUrl(u); });
    else setUrl(PLACEHOLDER_ICON);
    return () => { live = false; };
  }, [id]);
  return url;
}
